export default {"src":"/_next/static/media/3.0bc433b8.svg","height":130,"width":120,"blurWidth":0,"blurHeight":0};